import { FEED_INSPECT_BTN, FEED_LINK } from './investigation/feedCardStyles';
import { useFeedInspect } from './FeedInspectProvider';
import { canOpenFeedInspect, resolveInspectUrl } from '../utils/feedInspectUtils';
import { displayHostFromUrl } from '../utils/personFeedDisplay';

/**
 * @param {{
 *   res: object,
 *   className?: string,
 *   label?: string,
 *   onInspect?: Function,
 *   testId?: string,
 * }} props
 */
export function FeedInspectButton({
  res,
  className,
  label = 'Inspect',
  onInspect,
  testId = 'feed-inspect-btn',
}) {
  const { openInspect } = useFeedInspect();
  if (!canOpenFeedInspect(res)) return null;

  const handleClick = () => {
    if (typeof onInspect === 'function') {
      onInspect(res);
      return;
    }
    openInspect(res);
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      className={[FEED_INSPECT_BTN, className].filter(Boolean).join(' ')}
      data-testid={testId}
    >
      {label}
    </button>
  );
}

/**
 * @param {{ res: object, className?: string, fallback?: string, compactHost?: boolean }} props
 */
export function FeedInspectUrlLink({ res, className, fallback = '', compactHost = false }) {
  const url = resolveInspectUrl(res);
  if (!url) {
    return fallback ? <p className="font-mono text-[11px] text-slate-500">{fallback}</p> : null;
  }
  const label = compactHost ? `${displayHostFromUrl(url)} ↗` : url;
  return (
    <a
      href={url}
      target="_blank"
      rel="noreferrer"
      title={url}
      className={
        compactHost
          ? `inline-flex max-w-full items-center gap-1 truncate font-mono text-[11px] ${className || FEED_LINK}`
          : `break-all font-mono text-[11px] ${className || FEED_LINK}`
      }
    >
      {label}
    </a>
  );
}
